import { render, staticRenderFns } from "./purchaseApplyDetailList.vue?vue&type=template&id=d84ede94&scoped=true"
import script from "./purchaseApplyDetailList.vue?vue&type=script&lang=js"
export * from "./purchaseApplyDetailList.vue?vue&type=script&lang=js"
import style0 from "./purchaseApplyDetailList.vue?vue&type=style&index=0&id=d84ede94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84ede94",
  null
  
)

export default component.exports